// placing it in article-tile.d.ts does not work because d.ts files are special 
// https://stackoverflow.com/questions/38335668/how-to-refer-to-typescript-enum-in-d-ts-file-when-using-amd
export enum ViewType {
    Category = 'Category',
    Search = 'Search',
    TeaserSuggestion = 'TeaserSuggestion'
}

export enum SortContextActionType {
    SetSortSelected = 'SetSortSelected',
    SetGloveRating = 'SetGloveRating',
    ResetRegularSortValues = 'ResetRegularSortValues',
    ResetGloveSortValues = 'ResetGloveSortValues'
}

export enum ArticleTileContextActionType {
    SetMspOrigin = 'SetMspOrigin'
}

export enum MatchEyecatcherType {
    percentage = 1,
    pro,
    contra,
}

export enum PipAttributeType {
    Legal = 0,
    Marketing = 1
}

export enum EsClass {
    FSP = 'fsp',
    ALL = 'all',
    Clothing = '01',
    Footwear = '02',
    PersonalProtection = '03',
    Tools = '04',
    ToolsAndEquipment = '05'
}

export class EsClassGroup {
    public static FSP = ['fsp'];
    public static ALL = ['all'];
    public static Clothing = ['01', '0201', '0202', '010801'];
    public static Footwear = ['0108', '0203'];
    public static PersonalProtection = ['03'];
    public static Tools = ['0401', '0404', '0204'];
    public static ToolsAndEquipment = ['04', '05'];
}

//Split the comma-separated string stored in the enum for the given key.
export function esClassGroupToArray(esClass: EsClass): string[] {
    switch(esClass) {
        case EsClass.FSP:
            return EsClassGroup.FSP;
        case EsClass.ALL:
            return EsClassGroup.ALL;
        case EsClass.Clothing:
            return EsClassGroup.Clothing;
        case EsClass.Footwear:
            return EsClassGroup.Footwear;
        case EsClass.PersonalProtection:
            return EsClassGroup.PersonalProtection;
        case EsClass.Tools:
            return EsClassGroup.Tools;
        case EsClass.ToolsAndEquipment:
            return EsClassGroup.ToolsAndEquipment;
        default:
            return [];
    }
}

function getEsClassName(value: string): string | undefined {
    // Loop through object keys
    return (Object.keys(EsClass) as (keyof typeof EsClass)[])
        .find(key => EsClass[key] === value);
}

// Return every code that does *not* belong to the provided group.
export function esClassGroupGetNotValid(esClass: EsClass): string[] {
    let result: string[] = [];

    for(const classGroupKey in EsClassGroup) {
        if(classGroupKey !== getEsClassName(esClass)) {
            result = result.concat(EsClassGroup[classGroupKey]);
        }
    }
    
    return result;
}